import {useGetAutoDeliveryDetailsExtendedDcx} from '@/api/consumerApi';
import {AUTO_DELIVERY_DCX_ORDER_STATUS_TYPES} from '@/consts/icc/iccAutoDeliveryStatusTypes';

const useAutoDeliveryDcxDetails = () => {
    const {
        data: {autoDelivery, order},
    } = useGetAutoDeliveryDetailsExtendedDcx();
    const {status: orderStatus} = order;

    const isOrderStatusExpected = orderStatus === AUTO_DELIVERY_DCX_ORDER_STATUS_TYPES.EXPECTED;

    return {autoDelivery, order, isOrderStatusExpected};
};

export default useAutoDeliveryDcxDetails;
